import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { Component, OnInit } from '@angular/core';
import {
  GpoRegistry,
  GpoWithRegistryKeyName
} from 'src/app/core/models/config-entities';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UpdateGpoPropertiesComponent } from './update-gpo-properties/update-gpo-properties.component';
import { AddGpoComponent } from './add-gpo/add-gpo.component';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UserRoleNames } from 'src/app/core/models/users';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-gpo-list',
  templateUrl: './gpo-list.component.html',
  styleUrls: ['./gpo-list.component.scss'],
})
export class GpoListComponent implements OnInit {
  constructor(
    private configEntityService: ConfigEntityService,
    public spinner: NgxSpinnerService,
    public snackBar: MatSnackBar,
    private navService: NavigationService,
    private dialog: MatDialog,
    private authenticationService: AuthenticationService
  ) {}

  result: GpoWithRegistryKeyName;
  filteredGpo: string[] = [];
  gpoNames: string[] = [];
  registryKeys: GpoRegistry[] = [];
  p: number = 1;
  filterText = new FormControl('');
  itemsPerPage: number = 10;
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  ngOnInit(): void {
    this.spinner.show('gpoList');
    this.configEntityService.sendActiveEntity('Group Policy');
    this.navService.sendChildData('Group Policy');
    this.navService.sendParentData('');
    this.getPolicyObjects();
    this.filterText.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value) => {
        this.filteredGpo = this.gpoNames.filter((gpo) =>
          gpo.toLowerCase().includes(value.toLowerCase())
        )
      });
  }

  getPolicyObjects() {
    this.configEntityService.getGroupPolicyObjects().subscribe({
      next: (data: any) => {
        this.spinner.hide('gpoList');
        if (data) {
          this.result = JSON.parse(JSON.stringify(data?.message));
          if (this.result) {
            if (this.result?.gpoNames) {
              this.gpoNames = this.result?.gpoNames;
              this.filteredGpo = this.gpoNames;
            }
            if (this.result?.registryKeys) {
              this.registryKeys = this.result?.registryKeys;
            }
          }
        } else {
          this.snackBar.open('Unable to fetch GPO list', 'Ok', {
            duration: 3000,
          });
        }
      },
      error: (err) => {
        this.spinner.hide('gpoList');
        console.error(err);
        this.snackBar.open('Unable to fetch GPO list', 'Ok', {
          duration: 3000,
        });
      },
    });
  }

  addNewGpo() {
    const dialogRef = this.dialog.open(AddGpoComponent, {
      disableClose: true,
      width: '400px',
    });

    dialogRef.componentInstance.gpoAdded.subscribe(() => {
      this.getPolicyObjects(); 
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.snackBar.open(res, 'Ok', { duration: 5000 });
      }
      this.getPolicyObjects(); 
    });
  }


  updateGpoProps(gpoName: string) {
    const dialogRef = this.dialog.open(UpdateGpoPropertiesComponent, {
      disableClose: true,
      width: '400px',
      data: {
        gpoName: gpoName,
        registryKeys: this.registryKeys,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getPolicyObjects();
      }
    });
  }

  deleteGPO(gpoName: string) {
  }
}
